import styled from 'styled-components';
export const Wrapper = styled.div `
  height: ${({ height }) => height}px;
  width: ${({ width }) => width}px;
`;
